
import store from '../index.js'
import api from '../../utils/api'

export const modules = ({
    store
})

export const state = ({
    _items: [],
    _page: {},
    _pdf: ''
});


export const mutations = {  
    setItems(state, items){
        state._items = [];
        state._items = items;
    },
    setPage(state, page){
        state._page = {};
        state._page = page;
    },
    setPdf(state, pdf){
        state._pdf = '';
        state._pdf = pdf;
    },
    setReset(state){
        state._items = [];
        state._page = {};
        state._pdf = '';
    },
};

export const actions = {
    async acIrosList({commit}, address) {
        try {
            const url = `/api/v1/estate/unique-nos?address=${address}`;
            const res = await api.get(url);
            commit('setItems', res.data?.code === 0 ? res.data?.data.dataList : []);          
            commit('setPage', res.data?.code === 0 ? res.data?.data.paginationInfo : {});
            return res.data?.code === 0;
        } catch (error) {
            return false;
        }
    },
    async acIrosPdfDownload({commit}, uniqueNo){
        try {
            const url = `/api/v1/estate/iros-pdf?unique_no=${uniqueNo}`;
            const res = await api.get(url);
            commit('setPdf', res.data?.code === 0 && res.data?.data?.length ? res.data?.data : '');
            return res.data?.code === 0;
        } catch (error) {
            return false;
        }
    }
};


export const getters = {

};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}